(() => {
    'use strict';

    function eventService($http) {

        const urlBase = '/webapi/eventsservice/';

        const get = id => $http.get(urlBase + 'get/' + id).then(result => result.data.data);

        return {
            get: get
        };
    }

    angular.module('Uscapp').service('eventService', ['$http', eventService]);

})();